var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"student-mini-card",class:_vm.size},[_c('user-picture',{attrs:{"user":_vm.student}}),_vm._v(_vm._s(_vm.student.first_name || 'Student '+(_vm.index+1)))],1)}
var staticRenderFns = []

export { render, staticRenderFns }